import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2 pt-[45px]">
      <div className="flex items-center justify-center mx-auto section2-container">
        <div className="mx-[1.5%]">
          <img
            className="w-[120px]"
            alt="Award Logo"
            src="/assets/go-awards-logo.png"
          ></img>
        </div>

        <div className="mx-[1.5%]">
          <img
            className="w-[97px]"
            alt="Award Logo"
            src="/assets/award2.png"
          ></img>
        </div>

        <div className="mx-[1.5%]">
          <img
            className="w-[119px]"
            alt="Award Logo"
            src="/assets/secp-logo.jpg"
          ></img>
        </div>

        <div className="mx-[1.5%]">
          <img
            className="w-[116px]"
            alt="Award Logo"
            src="/assets/pasha-logo.jpg"
          ></img>
        </div>
      </div>
    </div>
  );
}
